import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TextFilter } from '@app/shared/components/filter/filter-item/text-filter-item/text-filter.model';

@Component({
  selector: 'ap-table-text-filter',
  templateUrl: './table-text-filter.component.html',
  styleUrls: ['./table-text-filter.component.css']
})
export class TableTextFilterComponent {

  @Input() filter: TextFilter;

  @Output() save = new EventEmitter<TextFilter>();

  constructor() { }

  onEnter() {
    this.save.emit(this.filter);
  }
}
